import type { ReactNode } from 'react';

import { cn } from '@/shared/utils/cn';

interface Props {
  title: ReactNode;
  description: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function OverlayBanner({ title, description, action, className }: Props) {
  return (
    <div className={cn('pointer-events-none absolute', className)}>
      <div className="border-primary shadow-primary/20 bg-background/70 pointer-events-auto mx-auto w-full max-w-3xl rounded-2xl border px-8 py-7 shadow-2xl backdrop-blur-sm sm:px-10 sm:py-8">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between sm:gap-8">
          <div className="min-w-0 max-w-2xl">
            <h2 className="text-foreground text-xl font-semibold tracking-tight">{title}</h2>
            <p className="text-muted-foreground mt-3 text-sm leading-6">{description}</p>
          </div>
          {action}
        </div>
      </div>
    </div>
  );
}
